import { render } from "./UserSideMenuV1.vue?vue&type=template&id=65ff0868&scoped=true&ts=true"
import script from "./UserSideMenuV1.vue?vue&type=script&lang=ts"
export * from "./UserSideMenuV1.vue?vue&type=script&lang=ts"

import "./UserSideMenuV1.vue?vue&type=style&index=0&id=65ff0868&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ff0868"]])

export default __exports__